import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { RasterTileType } from "../interface";
import { defaultFormat, getTileBuffer, getTileImage } from "../utils/tile/getRasterTile";
var DEFAULT_CONFIG = {
  tileSize: 256,
  minZoom: 0,
  maxZoom: Infinity,
  zoomOffset: 0
};
export var rasterDataTypes = [RasterTileType.ARRAYBUFFER, RasterTileType.RGB];

function isUrlError(url) {
  if (Array.isArray(url) && url.length === 0) return true;
  if (!Array.isArray(url) && typeof url !== 'string') return true;
  return false;
}
/**
 *
 * @param data
 * @param cfg
 * @returns
 */


export default function rasterTile(data, cfg) {
  if (isUrlError(data)) throw new Error('tile server url is error');
  var tileDataType = (cfg === null || cfg === void 0 ? void 0 : cfg.dataType) || RasterTileType.IMAGE; // Tip: RasterTileType.RGB 是彩色多通道的数据纹理，同样走数据纹理的请求

  if (tileDataType === RasterTileType.RGB) tileDataType = RasterTileType.ARRAYBUFFER;

  var getTileData = function getTileData(tileParams, tile) {
    switch (tileDataType) {
      case RasterTileType.IMAGE:
        return getTileImage(data, tileParams, tile);

      case RasterTileType.ARRAYBUFFER:
        return getTileBuffer(data, tileParams, tile, (cfg === null || cfg === void 0 ? void 0 : cfg.format) || defaultFormat, cfg === null || cfg === void 0 ? void 0 : cfg.operation);

      default:
        return getTileImage(data, tileParams, tile);
    }
  };

  var tilesetOptions = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), cfg), {}, {
    getTileData: getTileData
  });

  return {
    data: data,
    dataArray: [],
    tilesetOptions: tilesetOptions,
    isTile: true
  };
}